module.exports = __webpack_public_path__ + "img/744.37ba9e8a.jpg";